<div>
    <hub-modal-header headerText="{{ 'general.session_expiry.title' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="row">
        <div class="col-lg-12">
            <p>{{ 'general.session_expiry.message' | translate }}</p>
            <p-dropdown [options]="snoozeOptions" [(ngModel)]="snoozeMinutes"
                optionLabel="label" optionValue="value"
                [style]="{ width: '100%' }"></p-dropdown>
        </div>
    </div>
</div>

<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'general.session_expiry.snooze' | translate"
            [style]="'outline'"
            [size]="'xl'"
            (buttonClick)="snooze()"></hub-button>
        <hub-button [text]="'general.logout' | translate"
            [style]="'primary'"
            [size]="'xl'"
            (buttonClick)="logout()"></hub-button>
    </div>
</div>
